import React from 'react';
import { useIntl } from 'react-intl';
import ExpandableWrapper from '../ExpandableWrapper';
import MarkdownEditor from '../MarkdownEditor';

const Description = ({
  value, onChange, selected, expanded
}) => {
  const intl = useIntl();

  return (
    <ExpandableWrapper onChange={ onChange } selected={ selected } id="description" title={ intl.formatMessage({ id: 'manage.detail.tab.general.description' }) } expanded={ expanded }>
      <MarkdownEditor value={ value } />
    </ExpandableWrapper>
  );
};

export default Description;
